import { InAppMessageDeliverProcessor } from "../../deliver/InAppMessageDeliverProcessor"
import { InAppMessageDelayManager } from "../../delay/InAppMessageDelayManager"
import { InAppMessageDeliverRequest } from "../../deliver/InAppMessageDeliverRequest"
import { InAppMessageScheduleRequest } from "../InAppMessageScheduleRequest"
import { InAppMessageScheduleResponse } from "../InAppMessageScheduleResponse"
import { InAppMessageScheduleType } from "../InAppMessageScheduleType"
import { AbstractInAppMessageScheduler } from "./AbstractInAppMessageScheduler"

export class TriggeredInAppMessageScheduler extends AbstractInAppMessageScheduler {
  constructor(
    private readonly deliverProcessor: InAppMessageDeliverProcessor,
    private readonly delayManager: InAppMessageDelayManager
  ) {
    super()
  }

  /**
   * @override
   */
  supports(scheduleType: InAppMessageScheduleType): boolean {
    return scheduleType === "TRIGGERED"
  }

  /**
   * @override
   */
  deliver(request: InAppMessageScheduleRequest): InAppMessageScheduleResponse {
    const deliverRequest = InAppMessageDeliverRequest.of(request)
    const deliverResponse = this.deliverProcessor.process(deliverRequest)
    return InAppMessageScheduleResponse.of(request, "DELIVER", deliverResponse)
  }

  /**
   * @override
   */
  delay(request: InAppMessageScheduleRequest): InAppMessageScheduleResponse {
    const delay = this.delayManager.registerAndDelay(request)
    return InAppMessageScheduleResponse.of(request, "DELAY", null, delay)
  }

  /**
   * @override
   */
  ignore(request: InAppMessageScheduleRequest): InAppMessageScheduleResponse {
    return InAppMessageScheduleResponse.of(request, "IGNORE")
  }
}
